import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';

import PromoCodeForm from '../../../../components/SiteAdmin/PromoCode/PromoCodeForm';
import NotFound from '../../../../components/NotFound/NotFound';

import getPromoCodeQuery from './getPromoCode.graphql';

import s from './EditPromoCode.css';
class EditPromoCode extends React.Component {
  static defaultProps = {
    promoCode: {
      loading: true
    }
  };

  render() {
    const { title, promoCode: { loading, getPromoCode } } = this.props;

    let initialValues = {};

    if (!loading && getPromoCode) {
      initialValues = getPromoCode;
    }

    if (!loading && !getPromoCode) {
      return <NotFound title={'Page Not Found'} />
    } else {
      return (
        <div className={s.paddingRoutesSection}>
          {
            !loading && <PromoCodeForm initialValues={initialValues} />
          }
        </div>
      );
    }
  }
}

export default compose(
  withStyles(s),
  graphql(getPromoCodeQuery, {
    name: 'promoCode',
    options: (props) => ({
      ssr: false,
      fetchPolicy: 'network-only',
      variables: {
        id: props.id
      }
    })
  }))(EditPromoCode);
